import React from 'react';
import {
  Avatar,
  Button,
  ButtonProps,
  IconButton,
  useDisclosure,
} from '@cardboard-ui/react';
import { ClockIcon } from 'components/icons';
import { t } from '@lingui/macro';
import { graphql, useFragment } from 'utils/graphClient';
import { TodoDueDate_todo$key } from './__generated__/TodoDueDate_todo.graphql';
import { useI18n } from 'utils/i18n';
import { TodoDueDateModal } from './TodoDueDateModal';

const fragment = graphql`
  fragment TodoDueDate_todo on Todo {
    id
    ...TodoDueDateModal_todo
    dueDate
    canSchedule {
      value
    }
  }
`;

interface TodoDueDateProps {
  todo: TodoDueDate_todo$key;
}

export const TodoDueDate: React.FC<TodoDueDateProps> = ({ todo }) => {
  const {
    id,
    dueDate: initialDueDate,
    canSchedule,
    ..._todo
  } = useFragment(fragment, todo);

  const { format } = useI18n();

  const localisedDueDate =
    initialDueDate && format(new Date(initialDueDate), 'PP');

  const { isOpen, onOpen, onClose } = useDisclosure();

  const buttonprops: Partial<ButtonProps> = {
    size: 'xs',
    variant: 'ghost',
    isDisabled: !canSchedule.value,
    onClick: onOpen,
  };

  return (
    <>
      {localisedDueDate ? (
        <Button {...buttonprops}>{localisedDueDate}</Button>
      ) : (
        <IconButton
          {...buttonprops}
          borderRadius="full"
          aria-label={t`Change due date`}
          _hover={{
            opacity: 0.8,
          }}
        >
          <Avatar
            size="xs"
            bg="gray.200"
            color="gray.600"
            icon={<ClockIcon />}
          />
        </IconButton>
      )}

      <TodoDueDateModal todo={_todo} isOpen={isOpen} onClose={onClose} />
    </>
  );
};
